// extracted by mini-css-extract-plugin
export default {"root":"v3pR5RFfme","item_top":"hBCtzLbJrs","item":"pbY2c3ZvZC"};